import { IsInt } from 'class-validator';

export class ForgotPasswordRequestDto {
  @IsInt()
  mobile!: number;
}
